export default __webpack_public_path__ + "static/media/uploader-abbottXtra-1.959b9273.png";